import { ColDef, themeAlpine } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import React, { useMemo } from "react";

import { IgTableWrapper } from "@intelligems/ig-theme";
import { AdminStripeProductLinkDto } from "@intelligems/ig-types";
import { DecimalFormat } from "@src/features/admin/components/utils";
import { ViewColumn } from "@src/features/admin/pages/agencies/components/Tables/StripeProductLinksTable/renderers/ViewColumn";
import { theme } from "@src/theme";

interface SubscriptionsTableProps {
  products: AdminStripeProductLinkDto[];
  backgroundColor: string;
}

const myTheme = themeAlpine.withParams({
  fontFamily: theme.typography.fontFamily,
});

export const StripeProductLinksTable = ({
  products,
  backgroundColor,
}: SubscriptionsTableProps) => {
  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1,
    };
  }, []);

  const columnDefs: ColDef<AdminStripeProductLinkDto>[] = useMemo(
    () => [
      {
        flex: 2,
        headerName: "Name",
        field: "stripeProduct.name",
        sortable: true,
        cellStyle: { justifyContent: "start" },
        valueGetter: (params) => {
          if (!params.data?.stripeProduct) {
            return "-";
          }

          const parts = [params.data?.stripeProduct.name || "-"];
          if (params.data?.stripeProduct.priceName) {
            parts.push(params.data?.stripeProduct.priceName);
          }
          return parts.join(": ");
        },
      },
      {
        flex: 1,
        headerName: "Quantity",
        field: "stripeProduct.quantity",
        sortable: true,
        valueFormatter: (params) => {
          // params.data.
          return params.value ? DecimalFormat.format(params.value) : "-";
        },
      },
      {
        maxWidth: 100,
        flex: 1,
        headerName: "Price",
        field: "stripeProduct.priceDescription",
        sortable: true,
      },
      {
        headerName: "",
        cellRenderer: ViewColumn,
      },
    ],
    [products]
  );

  return (
    <IgTableWrapper minHeight={"100px"} height={null}>
      <AgGridReact<AdminStripeProductLinkDto>
        theme={myTheme}
        rowData={products}
        defaultColDef={defaultColDef}
        columnDefs={columnDefs}
        domLayout={"autoHeight"}
        headerHeight={products.length ? 25 : 0}
        suppressCellFocus={true}
        suppressRowHoverHighlight={true}
      />
    </IgTableWrapper>
  );
};
